import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { WaitingOnOhioTitleProcessingDto, WaitingOnOhioTitleProcessingQueryParams } from 'dtos/toDoLists/ohioBuildABoxes'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/ohio-build-a-boxes/waiting-on-ohio-title-processing`

export const getWaitingOnOhioTitleProcessingToDoList = (queryParams: WaitingOnOhioTitleProcessingQueryParams) =>
  apiClient.get<ApiResponse<WaitingOnOhioTitleProcessingDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)
